module.exports = __webpack_public_path__ + "40bc639e98ae99c03ae0c002ca069241.pdf";